import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../config/constants';
export default function Courses() {
	const { t } = useTranslation();

	const [activeButton, setActiveButton] = useState('');
	const [price, setPrice] = useState([]);
	const [coursesData, setCoursesData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [facultyId, setFacultyId] = useState('');

	const baseUrl = BASE_URL;
	// جلب جميع الكليات عند تحميل المكون
	useEffect(() => {
		const fetchFaculties = async () => {
			try {
				const res = await fetch(`${baseUrl}/api/faculty`);
				const data = await res.json();

				// تعيين أول كلية كـ default
				if (data.length > 0) {
					setFacultyId(data[0].id);
					setActiveButton('FACULTY');
				}
			} catch (err) {
				console.error('Error fetching faculties:', err);
			}
		};
		fetchFaculties();
	}, []);

	// جلب الدورات حسب الكلية أو السعر
	useEffect(() => {
		const fetchCourses = async () => {
			setLoading(true);
			setError(false);

			try {
				let url = '';

				if (facultyId) {
					url = `${baseUrl}/api/v1/courses/faculty/${facultyId}`;
				} else if (price.length) {
					const filters = `?filters={"paymentType":${JSON.stringify(price)}}`;
					url = `${baseUrl}/api/v1/courses/public${filters}&limit=6`;
				} else {
					url = `${baseUrl}/api/v1/courses/public?limit=6`;
				}

				const res = await fetch(url);
				const data = await res.json();

				const coursesArray = Array.isArray(data) ? data : data.courses || [];
				setCoursesData(coursesArray.slice(0, 6));
			} catch (err) {
				console.error('Error fetching courses data:', err);
				setError(true);
			} finally {
				setLoading(false);
			}
		};

		fetchCourses();
	}, [price]);

	return (
		<div className='courses mt-20'>
			{/* Banner */}
			<section className='bg-main h-[35vh] md:h-[50vh] flex justify-center items-center mb-16'>
				<h2 className='text-2xl md:text-5xl text-white font-semibold'>
					{t('courses')}
				</h2>
			</section>

			{/* Courses Section */}
			<section className='container mb-20'>
				<div className='flex flex-col gap-6 items-center'>
					<h2 className='text-main text-3xl font-semibold mb-10'>
						{t('topFeaturedCourses')}
					</h2>

					{/* Faculty Buttons */}

					{/* Courses Grid */}
					<div className='container flex flex-col-reverse lg:flex-row-reverse gap-8'>
						<div className='w-full grid grid-cols-1 md:grid-cols-3 gap-6 mb-12'>
							{loading ? (
								<div className='h-20 flex justify-center w-full items-center bg-main col-span-2 text-white'>
									Loading...
								</div>
							) : error ? (
								<div className='h-20 flex justify-center items-center bg-main col-span-2 text-white'>
									{t('noCoursesFound')}
								</div>
							) : (
								coursesData.map((course) => (
									<NavLink
										key={course.id}
										to={`/courses/${course.id}`}
										className='card group flex flex-col gap-2 overflow-hidden rounded-lg border-[#eee] border-2 font-semibold'>
										<div className='image w-full h-[150px] md:h-[200px] overflow-hidden'>
											<img
												loading='lazy'
												src={`${baseUrl}/${course.photo?.path}`}
												alt={course.name}
												className='w-full h-full object-cover transition-transform duration-500 group-hover:scale-110'
												referrerPolicy='no-referrer'
											/>
										</div>
										<div className='course-data text-main flex flex-col gap-3 px-2'>
											<p>{course.name}</p>
											<div className='text-sm text-start group-hover:text-secondary transition-all duration-500'>
												{course.description}
											</div>
											<div className='flex justify-between border-t-2 border-[#eee] p-3 text-sm'>
												<p>{course.duration} Hour</p>
												<p>{course.price} $</p>
											</div>
										</div>
									</NavLink>
								))
							)}
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
